module.exports = __webpack_public_path__ + "static/media/amazon.d9e46af9.JPG";